// sagas/insightSaga.ts
import { call, delay, fork, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';

// Action Types
export const FETCH_INSIGHTS_REQUEST = 'FETCH_INSIGHTS_REQUEST';
export const FETCH_INSIGHTS_SUCCESS = 'FETCH_INSIGHTS_SUCCESS';
export const FETCH_INSIGHTS_FAILURE = 'FETCH_INSIGHTS_FAILURE';
export const RESET_INSIGHTS = 'RESET_INSIGHTS';

export const fetchInsightsRequest = () => ({
	type: FETCH_INSIGHTS_REQUEST,
});

export const fetchInsightsSuccess = (data: any) => ({
	type: FETCH_INSIGHTS_SUCCESS,
	payload: data,
});

export const resetInsights = () => ({
	type: RESET_INSIGHTS,
});

export const fetchInsightsFailure = (error: any) => ({
	type: FETCH_INSIGHTS_FAILURE,
	payload: error,
});

function* fetchInsightsSaga() {
	while (true) {
		try {
			const { data } = yield call(
				axios?.get,
				'https://apis.vcred.trade/api/cathena/insights',
			);
			yield put(fetchInsightsSuccess(data));
		} catch (error) {
			yield put(fetchInsightsFailure(error));
		}
		yield delay(120000); // 2 minutes in milliseconds
	}
}

// Watcher Saga
function* watchFetchInsights() {
	yield takeLatest(FETCH_INSIGHTS_REQUEST, fetchInsightsSaga);
}

// Root Saga
export default function* insightSaga() {
	yield fork(watchFetchInsights);
}
